import React, { useState } from "react";

import { useRequest } from "ahooks";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { updateOrderApi } from "../../api";
import { Button, Checkbox, Textarea, TextInput } from "@mantine/core";
import { PaperClipOutlined } from "@ant-design/icons";
import {
  ApprovalStatus,
  Position,
  PositionImage,
  UserOrder,
} from "../../interfaces";
import Attachments from "./Attachments";

type Props = {
  current: PositionImage;
  item: Position;
  order: UserOrder;
  callback: (order: UserOrder) => void;
};

const RenderDontApproveView: React.FC<Props> = ({
  current,
  item,
  order,
  callback,
}) => {
  const reasons = current?.rejectedReason?.split(" ");
  const { t } = useTranslation();
  const [approved, setApproved] = useState<boolean>(false);

  const { loading, run } = useRequest(updateOrderApi, {
    manual: true,
  });

  const approveImage = async (fullName: string) => {
    const positions = order.positions.map((position) => {
      if (
        position.articleNumber === item.articleNumber &&
        position.heightByMm === item.heightByMm &&
        position.widthByMm === item.widthByMm
      ) {
        return {
          ...position,
          positionImage: position?.positionImage?.map((positionImage) => {
            if (positionImage.key === current.key) {
              return {
                ...positionImage,
                approvalStatus: ApprovalStatus.Yes,
                rejectedReason: "",
                rejectedDescription: "",
                fullName,
              };
            }

            return positionImage;
          }),
        };
      }

      return position;
    });

    const updatedOrder = await run({
      id: order.id,
      positions,
    });

    if (updatedOrder) {
      toast.success(t("imageApproved"));
      callback(updatedOrder);
    }
  };
  const deleteImage = async () => {
    const positions = order.positions.map((position) => {
      if (
        position.articleNumber === item.articleNumber &&
        position.heightByMm === item.heightByMm &&
        position.widthByMm === item.widthByMm
      ) {
        return {
          ...position,
          positionImage: position?.positionImage?.filter(
            (pImage) => pImage.key !== current.key
          ),
        };
      }

      return position;
    });

    // ... Rest der Funktion bleibt unverändert

    const updatedOrder = await run({
      id: order.id,
      positions,
    });

    if (updatedOrder) {
      toast.success(t("positionImageRemoved"));
      callback(updatedOrder);
    }
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
  };

  const handleGrantRelease = (e: any) => {
    e.preventDefault();

    if (!approved) return;

    const fullName = e.target["fullName"].value;

    approveImage(fullName);
  };
  const handleGrantDelete = (e: any) => {
    e.preventDefault();

    deleteImage();
  };

  return (
    <div className="image-dont-approve">
      <h2 className="text-center">{t("printdataRejected")}</h2>

      <form
        //style={{ pointerEvents: "none" }}
        onSubmit={handleSubmit}
        className="mt-70"
      >
        <div className="approve-form-row">
          <Checkbox
            name="ResolutionLow"
            label={t("resolutionTooLow")}
            defaultChecked={!!reasons?.find((s) => s === "ResolutionLow")}
          />
        </div>
        <div className="approve-form-row">
          <Checkbox
            name="WrongColor"
            label={t("colorsAreWrong")}
            defaultChecked={!!reasons?.find((s) => s === "WrongColor")}
          />
        </div>
        <div className="approve-form-row">
          <Checkbox
            name="Other"
            label={t("other")}
            defaultChecked={!!reasons?.find((s) => s === "Other")}
          />
        </div>

        <Textarea
          name="description"
          placeholder={t("typeInHere")}
          defaultValue={current?.rejectedDescription}
          minRows={4}
        ></Textarea>
      </form>

      <div className="image-files mt-10">
        <p>
          {t("attachedFiles")} <PaperClipOutlined />
        </p>

        <Attachments files={current?.files || []} />
      </div>

      <div className="grant-release mt-30">
        <span>{t("grantReleaseText")}</span>

        <form className="form gap-10 mt-10" onSubmit={handleGrantRelease}>
          <Checkbox
            label={t("grantReleaseConfirm")}
            checked={approved}
            onChange={(e: any) => setApproved(e.target.checked)}
          />
          <div className="form__row">
            <TextInput
              type="text"
              name="fullName"
              placeholder={t("fullName")}
              required
            />
          </div>
          <Button
            size="lg"
            loading={loading}
            disabled={!approved || loading}
            type="submit"
          >
            {t("grantReleaseFile")}
          </Button>
          <Button
            size="lg"
            //loading={loading}
            color="red"
            type="button"
            onClick={handleGrantDelete}
          >
            {t("deleteFile")}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default RenderDontApproveView;
